// DS3.2
import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import InputErrorMessage from '../../lego/InputErrorMessage';
import InputHint from '../../lego/InputHint';
import InputLabelSubText from '../../lego/InputLabelSubText';
import InputLabelText from '../../lego/InputLabelText';
import InputSuccessMessage from '../../lego/InputSuccessMessage';
import FormElement from '../../layouts/FormElement';
import LimitedTextAreaInputField from '../../lego/LimitedTextAreaInputField';
import TextAreaInputField from '../../lego/TextAreaInputField';
/**
 * A multiline text input field with a label and some details.
 *
 * For use on our member subscription tier creation form.
 */ const TextArea = /*#__PURE__*/ React.forwardRef((_param, ref)=>{
    var { id , label , subLabel , isRequired , isLabelHidden , maxLength , details , validationResult , noBottomSpacing  } = _param, rest = _object_without_properties(_param, [
        "id",
        "label",
        "subLabel",
        "isRequired",
        "isLabelHidden",
        "maxLength",
        "details",
        "validationResult",
        "noBottomSpacing"
    ]);
    let wrappedDetails = null;
    const errorMessageId = `${id}-error`;
    const hintId = `${id}-hint`;
    switch(validationResult){
        case 'success':
            wrappedDetails = /*#__PURE__*/ React.createElement(InputSuccessMessage, null, details);
            break;
        case 'error':
            wrappedDetails = /*#__PURE__*/ React.createElement(InputErrorMessage, {
                id: errorMessageId
            }, details);
            break;
        default:
            wrappedDetails = details ? /*#__PURE__*/ React.createElement(InputHint, {
                id: hintId
            }, details) : undefined;
    }
    const commonInputProps = {
        id,
        isRequired,
        validationResult,
        ref,
        'aria-errormessage': validationResult === 'error' ? errorMessageId : undefined,
        'aria-describedby': validationResult === undefined && details ? hintId : undefined
    };
    return /*#__PURE__*/ React.createElement(FormElement, {
        inputId: id,
        isLabelHidden: isLabelHidden,
        noBottomSpacing: noBottomSpacing,
        label: /*#__PURE__*/ React.createElement(InputLabelText, {
            isRequired: isRequired
        }, label),
        subLabel: subLabel && /*#__PURE__*/ React.createElement(InputLabelSubText, null, subLabel),
        details: wrappedDetails
    }, maxLength === undefined ? /*#__PURE__*/ React.createElement(TextAreaInputField, _extends({}, commonInputProps, rest)) : /*#__PURE__*/ React.createElement(LimitedTextAreaInputField, _extends({}, commonInputProps, {
        maxLength: maxLength
    }, rest)));
});
TextArea.displayName = 'TextArea';
export default TextArea;
